import Client from '@/repositories/clients/fetchClient';
import type { GetPackagesResponse } from '@/types/package';

const resource = 'package';

export const packageRepository = {
  getAll: () => Client.get<GetPackagesResponse>(`${resource}s`),
};
